import { DidYouKnow } from "../type";
import { Button } from "../atoms/Button";
import { Primary } from "../../Flavor";
import { CardContent } from "../atoms/CardContent";

interface DidYouKnowCardProps {
  content: DidYouKnow;
  onClose: () => void;
}

export const DidYouKnowCard = (props: DidYouKnowCardProps) => {
  return (
    <div className=" p-5 w-[70%] h-fit text-center flex flex-col items-center rounded-[1em] justify-center bg-gradient-to-b from-white to-almost-true-gray ">
      <CardContent
        image={props.content.image}
        title={props.content.title}
        description={props.content.description}
        buttons={
          <Button
            label="Ok c'est noté"
            flavor={Primary}
            onClick={props.onClose}
          />
        }
      />
    </div>
  );
};
